<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Recurso"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <aplicacao-recurso-form
            operacaoProp="A"
            :aplicacaoRecurso="aplicacaoRecurso"
            :convenio="convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aplicacao-recurso-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AplicacaoRecursoForm from '../AplicacaoRecursos/AplicacaoRecursoForm.vue'

export default {
    components:{
        AplicacaoRecursoForm,
    },

    props: {
        convenio: Object,
        aplicacaoRecurso: Object, 
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aplicacaoRecurso){
            this.$store.dispatch('addRequest')
            let convenioRecurso = {
                idConvenio : this.convenio.idConvenio,
                idAplicacaoRecurso: aplicacaoRecurso.idAplicacaoRecurso,
                idNaturezaDespesa: aplicacaoRecurso.idNaturezaDespesa,
                idAcaoConvenio: aplicacaoRecurso.idAcaoConvenio,
                codSituacao: aplicacaoRecurso.codSituacao,
                nuValorFinanceiroSebrae: aplicacaoRecurso.nuValorFinanceiroSebrae,
                nuValorEconomicoSebrae: aplicacaoRecurso.nuValorEconomicoSebrae,
                nuValorFinanceiroParceiro: aplicacaoRecurso.nuValorFinanceiroParceiro,
                nuValorEconomicoParceiro: aplicacaoRecurso.nuValorEconomicoParceiro,
            }
            ConveniosServicos.atualizarAplicacaoRecurso(convenioRecurso)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Recurso atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaAplicacaoRecurso')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    },
}

</script>